import { styled } from '@mui/material/styles';

export const Wrapper = styled('div')``;
